import Vue from 'vue';
import Main from '../components/toast/Notification.vue';
import {PopupManager} from './popup';
import {isVNode} from './vdom';
const NotificationConstructor = Vue.extend(Main);

const headerElement = '.header-wrap';

let notificationOffset = () => {
  if (document.querySelector(headerElement)) {
    return document.querySelector(headerElement).offsetHeight;
  } else {
    return 0;
  }
};

let instance;
let instances = [];
let seed = 1;

const Notification = function(options) {
  if (Vue.prototype.$isServer) return;

  options = options || {};
  const userOnClose = options.onClose;
  const id = 'notification_' + seed++;
  const position = options.position || 'top-right';
  const headerHeight = notificationOffset();
  let verticalOffset = options.offset || headerHeight;

  options.onClose = function() {
    Notification.close(id, userOnClose);
  };

  if (!options.type === 'undefined') {
    options.type = 'primary';
  }

  instance = new NotificationConstructor({
    data: options,
  });

  if (isVNode(options.message)) {
    instance.$slots.default = [options.message];
    options.message = 'REPLACED_BY_VNODE';
  }

  if (isVNode(options.action)) {
    instance.$slots.action = [options.action];
    options.action = 'REPLACED_BY_VNODE';
  }

  instance.id = id;
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.visible = true;
  instance.dom = instance.$el;
  instance.dom.style.zIndex = PopupManager.nextZIndex() + 16000000;

  instances
    .filter((item) => item.position === position)
    .forEach((item) => {
      verticalOffset += item.$el.offsetHeight + 16;
    });

  verticalOffset += 16;
  // use verticalOffset set by user prop if there's one
  instance.verticalOffset = instance.verticalOffset > 0 ? instance.verticalOffset > 0 : verticalOffset;
  instances.push(instance);

  return instance;
};

['success', 'warning', 'info', 'alert'].forEach((type) => {
  Notification[type] = (options) => {
    if (typeof options === 'string' || isVNode(options)) {
      options = {
        message: options,
      };
    }
    options.type = type;

    return Notification(options);
  };
});

Notification.close = function(id, userOnClose) {
  let index = -1;
  const len = instances.length;
  const instance = instances.filter((instance, i) => {
    if (instance.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];

  if (!instance) return;

  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }

  instances.splice(index, 1);

  if (len <= 1) return;

  const position = instance.position;
  const removedHeight = instance.dom.offsetHeight;

  for (let i = index; i < len - 1; i++) {
    if (instances[i].position === position) {
      instances[i].dom.style[instance.verticalProperty] =
        parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
    }
  }
};

Notification.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

export default Notification;
